export default {
  moreButtonText: {
    id: 'EXPANDABLE_DROPDOWN_MORE_BUTTON_TEXT',
    description: 'More button text',
    defaultMessage: 'More',
  },
};
